import OrdersList from "./OrdersList";

const Kitchen = () => {

return (
    <div className="flex flex-col">
        <OrdersList/>
    </div>
);
};

export default Kitchen;